/**
 * Loads redirects from the API.
 *
 * @returns {Object} with redirects and fetch method.
 */
export const useRedirects = () => {
	const redirects = useState('redirects', () => {});

	const setRedirects = (data) => {
		redirects.value = data;
	};

	let data = { data: null };
	const fetchRedirects = async () => {
		data = await useWebsiteFetch('redirects');
		setRedirects(data.data);
	};

	return {
		redirects,
		fetchRedirects,
	};
};
